/**
 * Page shell around `PriorityQueue` — the "who to chase next" screen under the Contractor menu.
 *
 * The shell owns only the title and the full-height layout; the grid, filter row, contact drawer
 * and data fetching all live in `PriorityQueue` itself.
 */
import { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { PriorityQueue } from './PriorityQueue'

const PriorityQueueScreenComponent = () => {
  /* Single-viewport layout: the page itself never scrolls — only the grid body does. */
  return (
    <div css={tw`flex flex-col h-full overflow-hidden`}>
      <div css={tw`flex-none`}>
        <Typography variant="h2" css={tw`mb-4`}>
          Priority queue
        </Typography>
      </div>
      <PriorityQueue />
    </div>
  )
}

export const PriorityQueueScreen = memo(PriorityQueueScreenComponent)
